import React, {Component} from 'react';
import {ClipLoader} from 'react-spinners';

class LoadingComponent extends Component {
    render() {
        return <div className='sweet-loading-container'>
            <div className='sweet-loading'>
                <ClipLoader
                    color={'#858585'}
                    size={24}
                    loading={true}
                />
            </div>
        </div>
    }
}

export default LoadingComponent;


// WEBPACK FOOTER //
// ./src/Components/Loading.js